import { useSelector } from 'react-redux';
import { PayRateType } from 'shared/models/PaySettings';
import { selectAssignmentsById } from 'store/entities/configuration/configurationSelectors';

export const useAssignmentPayRateType = (assignmentId: string): PayRateType | undefined => {
    const assignmentsByIds = useSelector(selectAssignmentsById);
    return assignmentsByIds[assignmentId]?.pay_rate_type;
};
